"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
exports.__esModule = true;
exports.getFlag = exports.getTokenCurrencyIcon = exports.getCryptoCurrencyIcon = void 0;
var icons = __importStar(require("./data/icons/react"));
var flags = __importStar(require("./data/flags/react"));
function getIconId(_a) {
    var ticker = _a.ticker;
    var id = ticker.toLowerCase();
    if (!isNaN(parseInt(id.charAt(0), 10)))
        id = "_".concat(id); // fix variable name leading with a numerical value
    return id;
}
function getCryptoCurrencyIcon(currency) {
    return icons[getIconId(currency)];
}
exports.getCryptoCurrencyIcon = getCryptoCurrencyIcon;
function getTokenCurrencyIcon(token) {
    return token.disableCountervalue ? null : icons[getIconId(token)];
}
exports.getTokenCurrencyIcon = getTokenCurrencyIcon;
function getFlag(countryCode) {
    return flags["".concat(countryCode.toLowerCase(), "Flag")];
}
exports.getFlag = getFlag;
//# sourceMappingURL=react.js.map